import { render, staticRenderFns } from "./valuetypemenu.vue?vue&type=template&id=d1eb3902&"
import script from "./valuetypemenu.vue?vue&type=script&lang=js&"
export * from "./valuetypemenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports